// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Belt_List = require("@rescript/runtime/lib/js/Belt_List.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("../../cap/Property/components/PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let LotPropertyAttributes_lotProperty_graphql = require("../../../__generated__/LotPropertyAttributes_lotProperty_graphql.bs.js");

let convertFragment = LotPropertyAttributes_lotProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, LotPropertyAttributes_lotProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(LotPropertyAttributes_lotProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, LotPropertyAttributes_lotProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(LotPropertyAttributes_lotProperty_graphql.node, convertFragment, fRef);
}

let PropertyTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function LotPropertyAttributes(props) {
  let match = RescriptRelay_Fragment.useFragment(LotPropertyAttributes_lotProperty_graphql.node, convertFragment, props.propertyType);
  let attributes = Belt_List.concatMany([
    props.displayPropertyType ? ({
        hd: [
          match.displayName,
          "Empty"
        ],
        tl: /* [] */0
      }) : /* [] */0,
    {
      hd: [
        match.size.toString(),
        "SqftLot"
      ],
      tl: /* [] */0
    }
  ]);
  return JsxRuntime.jsx(PropertyAttributes.make, {
    propertyAttributes: attributes,
    size: props.size
  });
}

let make = LotPropertyAttributes;

exports.PropertyTypeFragment = PropertyTypeFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
